export enum TOOLTIP_COLOR {
  DARK = 'tooltip-dark',
  LIGHT = 'tooltip-light'
}
